.tooltipContainer {
	display: flex;
	padding: 2px 0px;
}

.shortcutContainer {
	background-color: var(--ds-background-neutral, var(--adg3-color-N400));
	border: 1px solid var(--ds-text-inverse, var(--adg3-color-N0));
	border-radius: 2px;
	padding: 0px 4px;
	margin: 2px 0px;
	margin-left: 4px;
}

.textContainer {
	display: flex;
	align-items: center;
}
